import i18next from 'i18next';
import React from 'react';

import { InpulseLabel } from '@commons/DeepsightComponents';
import { Tags } from '@commons/Tags';

import { Text, LabelContainer } from '../components/styledComponents';

const renderLabel = (item) => (
  <LabelContainer>
    <InpulseLabel
      color={item > 0 ? 'green' : 'red'}
      text={String(item).toLowerCase() === 'null' ? '0' : String(item)}
    />
  </LabelContainer>
);

const renderVariantsLabel = (variantsCount) => (
  <LabelContainer>
    <InpulseLabel color={variantsCount > 0 ? 'green' : 'orange'} text={String(variantsCount)} />
  </LabelContainer>
);

export const getColumns = (hasMultipleBrands, hasVariants, isInCentralKitchenOnlyPage) => {
  const columns = [
    {
      id: 'name',
      name: i18next.t('GENERAL.NAME'),
      displayName: i18next.t('GENERAL.NAME'),
      propertyKey: 'name',
      baseName: 'name',
      large: true,
      render: (item) => <Text highlighted>{item}</Text>,
    },
    {
      id: 'category',
      baseName: 'category',
      propertyKey: 'categoryId',
      displayName: i18next.t('ADMIN.SUPPLIERS.LIST_COLUMN_CATEGORY'),
      name: i18next.t('ADMIN.SUPPLIERS.LIST_COLUMN_CATEGORY'),
      filterType: 'string',
      filterStringAllowNone: true,
      render: (_, { category }) => <Text>{category || '-'}</Text>,
    },
    {
      id: 'quantity',
      baseName: 'quantity',
      propertyKey: 'quantity',
      displayName: i18next.t('ADMIN.RECIPES.QUANTITY'),
      name: i18next.t('ADMIN.RECIPES.QUANTITY'),
      excludeFromSearch: true,
      filterType: 'numeric',
      render: (item) => (item ? <Text>{item}</Text> : <Text>-</Text>),
    },
    {
      id: 'unit',
      baseName: 'unit',
      propertyKey: 'unit',
      displayName: i18next.t('GENERAL.TOGGLE_BUTTON_UNIT', { count: 1 }),
      name: i18next.t('GENERAL.TOGGLE_BUTTON_UNIT', { count: 1 }),
      excludeFromSearch: true,
      filterType: 'string',
      render: (item) => <Text>{item}</Text>,
    },
    {
      id: 'mappingsCount',
      baseName: 'mappingsCount',
      propertyKey: 'mappingsCount',
      displayName: i18next.t('ADMIN.RECIPES.COMPONENTS'),
      name: i18next.t('ADMIN.RECIPES.COMPONENTS'),
      filterType: 'numeric',
      excludeFromSearch: true,
      render: (item) => renderLabel(item),
    },
    {
      id: 'parentsCount',
      baseName: 'parentsCount',
      propertyKey: 'parentsCount',
      displayName: i18next.t('ADMIN.INGREDIENTS.USING'),
      name: i18next.t('ADMIN.INGREDIENTS.USING'),
      filterType: 'numeric',
      excludeFromSearch: true,
      render: (item) => renderLabel(item),
    },
  ];

  if (hasMultipleBrands) {
    columns.splice(1, 0, {
      id: 'brands',
      baseName: 'brands',
      propertyKey: 'brands',
      displayName: i18next.t('GENERAL.BRAND_PLURAL'),
      name: i18next.t('GENERAL.BRAND_PLURAL'),
      disableSort: true,
      render: (items) => {
        const names = items.map(({ name }) => name);

        return <Tags items={names} />;
      },
    });
  }

  if (isInCentralKitchenOnlyPage) {
    const parentsCountIndex = columns.findIndex(({ id }) => id === 'parentsCount');

    columns.splice(parentsCountIndex, 0, {
      id: 'productionStoresCount',
      baseName: 'productionStoresCount',
      propertyKey: 'productionStoresCount',
      displayName: i18next.t('ADMIN.RECIPES.PRODUCTION'),
      name: i18next.t('ADMIN.RECIPES.PRODUCTION'),
      filterType: 'numeric',
      excludeFromSearch: true,
      render: (item) => renderLabel(item),
    });
  }

  if (hasVariants) {
    columns.push({
      id: 'variantsCount',
      baseName: 'variantsCount',
      propertyKey: 'variantsCount',
      displayName: i18next.t('ADMIN.RECIPES.VARIANTS'),
      name: i18next.t('ADMIN.RECIPES.VARIANTS'),
      tooltipText: i18next.t('ADMIN.RECIPES.VARIANTS_COLUMN_TOOLTIP'),
      excludeFromSearch: true,
      filterType: 'numeric',
      render: renderVariantsLabel,
    });
  }

  return columns;
};
